import { primarySemiBoldFont, theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export const content = css`
  margin: 0;
  ${responsiveText.BODY.SM};
  color: var(--neutral-black-base);
`;

export const heading = css`
  ${responsiveText.HEADING.XS};
  margin: 0 0 ${spacing.xs}px;
  color: var(--neutral-black-base);
`;

export const accentLink = css`
  display: inline-block;
  ${primarySemiBoldFont};
  text-decoration: none;
  margin-top: ${spacing.lg}px;
  color: var(--brand-purple-base);
  text-decoration: underline;

  &:hover,
  &:focus {
    border-radius: 4px;
  }
`;
